import {createAction, createReducer} from 'redux-act'
import { translatedConfigSelector as configSelector } from '~/config'
import { select, apply, put, call, takeEvery, all } from 'redux-saga/effects'
import { get } from "lodash";

import { Entity, handleError } from '~/utils/entity-utils'

import API from '~/api'

const entityName = 'collection';
const entity = new Entity(entityName, API, configSelector);

// ACTIONS
export const actions = {
  ...entity.actions,
  fetchProducts: {
    request: createAction('fetch products request', (id) => ({id})),
    failure: createAction('fetch products failure', (message, error) => ({message, error})),
    success: createAction('fetch products  success', (products) => ({products}))
  },
};

// WORKERS
export const workers = {
  ...entity.workers,
  * fetchProducts(action, throwError=true) {
    const { id } = get(action, 'payload', {});

    try {
      const config = yield select(configSelector);
      const api = new API(config);
      const route = `collections/${id}/products/`;
      const response = yield apply(api, api.callRoute, [route, 'GET']);

      yield put(actions.fetchProducts.success(response.data));

      return response.data;
    } catch (e) {
      yield call(handleError, e, actions.fetchProducts);
      if(throwError) {
        throw e;
      }
    }
  },
};

// SAGA
export function * saga() {
  yield all([
    ...entity.saga,
    takeEvery(actions.fetchProducts.request().type, workers.fetchProducts),
  ]);
}

export const reducer = createReducer(entity.reducer, {});

export default {
  actions,
  workers,
  saga,
  reducer
}
